export const isCurrentUrl = (url: string) => {
  return window.location.pathname.toString().toLowerCase() === url.toString().toLowerCase();

};
